"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNextAsyncIteratorFactory = void 0;
const get_next_async_iterator_1 = require("./get-next-async-iterator");
function getNextAsyncIteratorFactory(callback) {
    return !callback
        ? get_next_async_iterator_1.getNextAsyncIterator
        : async (asyncIterator, index) => {
            try {
                return await (0, get_next_async_iterator_1.getNextAsyncIterator)(asyncIterator, index);
            }
            catch (err) {
                callback(err, index);
                return {
                    index,
                    result: {
                        done: true,
                    },
                };
            }
        };
}
exports.getNextAsyncIteratorFactory = getNextAsyncIteratorFactory;
